import React, { useCallback, useState } from 'react';
import { useParams, Routes, Route, useLocation } from 'react-router-dom';
import { useApi } from '../../../context/ApiProvider';
import { NavOptionsWithElementInterface } from '../../../shared/type/navOptions.type';
import CustomChakraButton from '../../CustomChakraButton/CustomChakraButton';
import Navigation from '../../Navigation/Navigation';
import CreateNewAdminThread from './CreateNewAdminThread/CreateNewAdminThread';
import GenericMessagePageComponent from './GenericMessagePageComponent';
import { CreateNewAnnouncement } from './CreateNewAnnouncement/CreateNewAnnouncement';

const MailBox = () => {
  const { id: tenantId } = useParams();
  const { apiTenantMessageController, apiTenantAnnouncementController } = useApi();

  const [refreshMessages, setRefreshMessages] = useState<() => void>(() => () => {});
  const [refreshAnnouncements, setRefreshAnnouncements] = useState<() => void>(() => () => {});
  const [showCreateNewMessagePopUp, setShowCreateNewMessagePopUp] = useState<boolean>(false);
  const [showCreateNewNotificationPopUp, setShowCreateNewNotificationPopUp] =
    useState<boolean>(false);

  const fetchMessagesFn = useCallback(
    ({ tenantId, pageNumber, pageSize, searchPhrase }: any) =>
      apiTenantMessageController('topic-list')
        .get(`/${tenantId}`, {
          params: { pageNumber, pageSize, searchPhrase }
        })
        .then((res) => res.data),
    []
  );

  const deleteMessagesFn = useCallback(
    (threadId: number) =>
      apiTenantMessageController('thread')
        .delete(``, {
          params: { threadId }
        })
        .then((res) => res.data),
    []
  );

  const fetchAnnouncementsFn = useCallback(
    ({ tenantId, pageNumber, pageSize, searchPhrase }: any) =>
      apiTenantAnnouncementController('list')
        .get(``, {
          params: { tenantId, pageNumber, pageSize, searchPhrase }
        })
        .then((res) => res.data),
    []
  );

  const deleteAnnouncementFn = useCallback(
    (announcementId: number) =>
      apiTenantAnnouncementController('')
        .delete(``, {
          params: { announcementId }
        })
        .then((res) => res.data),
    []
  );

  const navOptions: NavOptionsWithElementInterface[] = [
    {
      link: 'messages',
      name: 'Wiadomości',
      component: (
        <GenericMessagePageComponent
          sectionHeader={
            <div className="flex items-center justify-between gap-2 flex-wrap w-full">
              <div>
                <h2 className="font-semibold text-grayLight-900" style={{ fontSize: '30px' }}>
                  Wiadomości
                </h2>
              </div>

              <div>
                <CustomChakraButton
                  iconPosition="right"
                  icon="plus"
                  iconColor="#292524"
                  hierarchy="primary"
                  size="sm"
                  buttonProps={{ onClick: () => setShowCreateNewMessagePopUp(true) }}>
                  Nowa wiadomość
                </CustomChakraButton>
              </div>
            </div>
          }
          tenantId={tenantId || '0'}
          setRefreshMessages={setRefreshMessages}
          fetchMessagesFn={fetchMessagesFn}
          deleteMessagesFn={deleteMessagesFn}
        />
      )
    },
    {
      link: 'announcement',
      name: 'Komunikaty',
      component: (
        <GenericMessagePageComponent
          sectionHeader={
            <>
              <div>
                <h2 className="font-semibold text-grayLight-900" style={{ fontSize: '30px' }}>
                  Komunikaty
                </h2>
              </div>

              <div>
                <CustomChakraButton
                  iconPosition="right"
                  icon="plus"
                  iconColor="#292524"
                  hierarchy="primary"
                  size="md"
                  buttonProps={{ onClick: () => setShowCreateNewNotificationPopUp(true) }}>
                  Nowy komunikat
                </CustomChakraButton>
              </div>
            </>
          }
          tenantId={tenantId || '0'}
          setRefreshMessages={setRefreshAnnouncements}
          fetchMessagesFn={fetchAnnouncementsFn}
          deleteMessagesFn={deleteAnnouncementFn}
          hideSearchInput={true}
        />
      )
    }
  ];

  return (
    <section className="pt-spacing-3xl pb-12 gap-spacing-3xl">
      <div className="flex flex-col">
        <Navigation navOptions={navOptions} />
        <Routes>
          {navOptions.map((item) => (
            <Route key={item.link} path={`/${item.link}/*`} element={item.component} />
          ))}
        </Routes>
      </div>

      {showCreateNewMessagePopUp && (
        <CreateNewAdminThread
          isOpen={showCreateNewMessagePopUp}
          onClose={() => {
            refreshMessages();
            setShowCreateNewMessagePopUp(false);
          }}
        />
      )}

      {showCreateNewNotificationPopUp && (
        <CreateNewAnnouncement
          isOpen={showCreateNewNotificationPopUp}
          onClose={() => {
            refreshAnnouncements();
            setShowCreateNewNotificationPopUp(false);
          }}
        />
      )}
    </section>
  );
};

export default MailBox;
